<template>
  <div class="content">
    <img
      v-if="$parent.showLoader"
      class="loading"
      :src="$parent.icon.loading_icon"
    >

    <div
      class="footer"
      ref="BottomBox"
    >
      <div
        class="main-station d-flex align-items-center justify-content-center flex-nowrap position-relative"
        v-on:click="$parent.swapContent()"
      >
        <img
          v-if="reload_icon"
          height="18"
          class="cursor"
          :src="$parent.icon.reloading_icon"
          v-on:click.stop="reloadNearBusStop"
        >
        <img
          v-else
          height="18"
          :src="$parent.icon.pin_white_icon"
        >
        <div style="margin-left: 18px;">
          {{ $t('message.home.title') }}
        </div>
        <div
          v-if="!is_desktop"
          class="position-absolute"
          style="right: 16px;"
        >
          <img
            v-if=$parent.showContentDetails
            class="arrow"
            :src="$parent.icon.expand_icon"
          >
          <img
            v-else
            class="arrow"
            :src="$parent.icon.less_icon"
          >
        </div>
      </div>

      <div
        class="detail-station"
        v-bind:class="{active:$parent.showContentDetails}"
        v-if="search_results.length > 0"
      >
        <div
        v-for="(station, index) in search_results"
          v-bind:class="[{'d-none':!$parent.showContentDetails}]"
          :key="(station, index)"
        >
          <div
            class="details"
            v-bind:class="{'mt-0': index === 0}"
          >
            <div class="d-flex" style="padding: 2px 12px 9px 2px;">
              <div class="cursor mr-2">
                <div class="position-relative">
                  <img
                    :src="$parent.icon.stop_overlay_icon"
                  >
                  <img
                    class="position-absolute absolute-center"
                    :src="$parent.api_url + station.iconUrlHD"
                    style="width: 25px;"
                  >
                  </div>
              </div>
              <div class="flex-grow-1 text-left stackem px-0">
                <div
                  class="main-bus pt-2 pb-1 cursor"
                  v-on:click="getNearPlace(station)"
                  :title="$i18n.messages[$i18n.locale].message.click_detail"
                >
                  {{ station.name }}
                </div>
                <div
                  class="search-detail bus-station text-center bus-result"
                  v-for="(trip, index2) in station.passingTrips"
                  :key="(trip, index2)"
                  :title="trip.routeLongName + ' (' + trip.vehicleSubType + ')'"
                >
                  <router-link class="d-flex align-items-center px-2" :to="{ name: 'BusTrip', params: { tripId: trip.tripId, location: station.location } }">
                    <img
                      v-if="trip.hasGps"
                      height="14"
                      :src="$parent.icon.gps_icon"
                      class="mr-1"
                    >
                    {{ trip.name }}
                  </router-link>
                  <!-- &emsp; -->
                  <hr :style="'background: #' + trip.color + ''" />
                  &emsp;
                </div>
              </div>
            </div>
            <div class="details-bottom w-100 d-flex align-items-center justify-content-between pl-0">
              <div class="ml-2">
                <img
                  height="15"
                  :src="$parent.icon.walk_icon"
                  class="ml-1 mb-1"
                >
              </div>
              <div
                class="search-detail"
                v-if="station.travelTime > 1"
              >
                {{ station.travelTime }} {{ $t('message.minutes') }}
              </div>
              <div
                class="search-detail"
                v-else
              >
                {{ station.travelTime }} {{ $t('message.minute') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="detail-station"
        v-bind:class="{active:$parent.showContentDetails}"
        v-else
      >
        <div v-bind:class="[{'d-none':!$parent.showContentDetails}]">
          <div class="row details px-4 pb-0 m-auto">
            <h5
              class="m-auto py-2 pin-color"
              v-if="!$parent.showLoader"
            >
              {{ $t('message.home.no_results_msg') }}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Favorites from '@/components/Favorites'
import { mapActions } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      poi_url: process.env.POI_SERVICE_URL + '/',
      is_desktop: this.$parent.isDesktop(),
      reload_icon: false,
      search_results: {},
      search_favorites: {},
      bound_list: [],
      list_marker: [],
      //
      isMapMoveEventBinded: false,
      mapMoveDebounceTimer: null,
      autoSelectStop: false,
      isFirstPage: false
    }
  },
  computed: {
    isTrafficOn() {
      return this.$parent.config.map === longdo.Layers.TRAFFIC.name()
    }
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      this.reload_icon = true
      this.reloadNearBusStop()
    },
    isTrafficOn() {
      this.pinEvents()
    },
    '$parent.event_results': function() {
      this.pinEvents()
    }
  },
  updated: function() {
    this.$parent.matchHeight()
  },
  mounted() {
    this.$parent.isHideSearch = false
    this.$parent.showContent()
    this.$parent.close()

    if (this.isFirstPage) {
      this.autoSelectStop = true
    }

    this.showLoading()
    this.mapInit()
  },
  methods: {
    ...mapActions({
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading'
    }),
    mapInit() {
      let scope = this
      scope.$parent.mapInit()
      scope.$parent.map.Overlays.clear()

      scope.$parent.map.Event.bind('geolocation', scope.processGeolocation)
      scope.$parent.map.Event.bind('geolocationError', scope.processGeolocation)

      var loca = null
      if (!this.isFirstPage && this.$parent.lastLocation) {
        loca = this.$parent.lastLocation
      } else if (scope.$parent.currentLocation) {
        loca = scope.$parent.currentLocation
      }

      if (loca) {
        if (!scope.isMapMoveEventBinded) {
          scope.$parent.map.Event.bind('location', scope.onMapMove)
          scope.isMapMoveEventBinded = true
        }
        scope.$parent.map.location(loca)
      } else if (!this.isFirstPage) {
        scope.$parent.map.location(longdo.LocationMode.Geolocation)
      }

      scope.$parent.map.Event.bind('overlayClick', scope.onPoiPinClick)
      scope.pinEvents()
    },
    onPoiPinClick: function (overlay) {
      if (overlay.trafficEvent) {
        // event pins open their own popup
      } else if (this.list_marker.includes(overlay) || overlay.tc_station || overlay.stopFavorite) {
        try {
          var favorite = JSON.parse(overlay.favorite)
          this.getRouting(favorite)
        } catch (err) {
          try {
            var stopFav = JSON.parse(overlay.stopFavorite)
            this.$parent.goToStop(stopFav.id)
          } catch (err2) {
            var station = JSON.parse(overlay.station)
            this.$parent.map.Overlays.remove(overlay)
            this.getNearPlace(station)
          }
        }
      } else if (overlay.data) { // POI
        this.onLongdoPoiPinClick(overlay.data)
      }
    },
    onLongdoPoiPinClick: async function (overlayData) {
      // overlayData -> icon, id, lat, lon, name
      const scope = this
      const router = this.$router
      let redirectToMapTripList = false
      let stopName = overlayData.name
      if (scope.$i18n.locale === 'th') {
        stopName = stopName.replace('ป้ายรถประจำทาง ', '')
      } else {
        stopName = stopName.replace('Bus Stop ', '')
      }
      if (overlayData.icon === 'custom:__namtang_tc') {
        var url = scope.poi_url + 'search?key=' + process.env.MAP_API_KEY
        url += '&limit=1'
        url += '&status=A%2CN'
        url += '&keyword=' + overlayData.id

        this.showLoading()
        const response = await scope.axios.get(url)
        this.hideLoading()
        if (response.status == 200 && response.data) {
          const customId = response.data.data[0]?.custom_id // "N00017434"
          const stopId = customId.replace(/^N0+/, '')

          if (stopId) {
            redirectToMapTripList = true
            router.push({ name: 'MapTripList', params: { stationId: stopId } })
          }
        }
      }
      if (!redirectToMapTripList) {
        router.push({ name: 'Place', params: { data: overlayData } })
      }
    },
    processGeolocation(position) {
      if (this.$route.path === '/' && !this.isMapMoveEventBinded) {
        if (!position.coords) {
          this.autoSelectStop = false
        }
        this.getNearBusStop(
          position.coords
            ? { lon: position.coords.longitude, lat: position.coords.latitude }
            : this.$parent.map.location(),
          false,
          this.autoSelectStop
        )
      }
    },
    onMapMove() {
      clearTimeout(this.mapMoveDebounceTimer)
      const scope = this
      this.reload_icon = true
      var map_loca = this.$parent.map.location()
      this.mapMoveDebounceTimer = setTimeout(function() {
        scope.getNearBusStop(map_loca, true)
      }, 500)
    },
    reloadNearBusStop() {
      if (this.reload_icon) {
        var loca = this.$parent.map.location()
        this.getNearBusStop(loca)
      }
    },
    pinNearBusStop(loca, isAutoReload) {
      let scope = this
      var boundList = [loca]

      scope.clearNearbyPins()
      scope.$parent.showMyLocation()
      scope.reload_icon = false
      scope.list_marker = []

      if (scope.search_results.length > 0) {
        scope.search_results.forEach(function(item) {
          boundList.push(item.location)
          // favorite pin (drawn by pinStopFavorite below) represents this stop instead
          if (scope.$parent.isStopFavorite(item.id)) return
          var offset = scope.$parent.getPinOffset(item.pinImageUrlHD, !!(item.largePinIcon))

          var marker = new longdo.Marker(item.location, {
            title: item.name,
            icon: {
              urlHD: scope.$parent.api_url + item.pinImageUrlHD,
              offset: offset
            },
            clickable: true
          })

          marker.station = JSON.stringify(item)
          scope.$parent.map.Overlays.add(marker)
          scope.list_marker.push(marker)
        })
      }

      if (!isAutoReload) {
        scope.$parent.map.bound(
          longdo.Util.locationBound(boundList),
          loca,
          true
        )
        scope.bound_list = boundList
      }

      if (scope.$parent.is_login) {
        scope.search_favorites = scope.$parent.favorite_results
        scope.pinFavorite()
        scope.$parent.pinStopFavorite()
      }
    },
    clearNearbyPins () {
      const scope = this
      scope.$parent.map.Overlays.list().forEach(pin => {
        // remove only the nearby stop pins
        if (pin.station) scope.$parent.map.Overlays.remove(pin)
      })
    },
    // event pins, shown only when traffic mode is on
    pinEvents () {
      const scope = this
      if (!scope.$parent.map) return
      scope.clearEventPins()
      if (!scope.isTrafficOn) return

      scope.$parent.event_results.forEach(function (item) {
        var marker = new longdo.Marker(item.location, {
          title: item.title,
          icon: {
            urlHD: item.imageUrlHD,
            offset: scope.$parent.getPinOffset('event')
          },
          clickable: true,
          popup: {
            title: scope.escapeHtml(item.title || ''),
            detail: scope.escapeHtml(item.description || '') +
              (item.time ? `<div style="color: #8e8e8e; font-size: small; margin-top: 4px;">${scope.escapeHtml(item.time)}</div>` : ''),
            size: { width: 240 }
          }
        })

        marker.trafficEvent = JSON.stringify(item)
        scope.$parent.map.Overlays.add(marker)
      })
    },
    // remove only the event pins, keep bus stop and current location pins
    clearEventPins () {
      const scope = this
      scope.$parent.map.Overlays.list().forEach(pin => {
        if (pin.trafficEvent) scope.$parent.map.Overlays.remove(pin)
      })
    },
    escapeHtml (text) {
      const el = document.createElement('div')
      el.textContent = text
      return el.innerHTML
    },
    getNearPlace(station) {
      var loca = station.location
      if (loca == null) return

      let scope = this

      this.$parent.map.Overlays.list().forEach(pin => {
        if (pin.element().src == scope.$parent.icon.pin_fav) {
          scope.$parent.map.Overlays.remove(pin)
        }
      })

      if (!this.is_desktop) {
        this.$parent.focusPin(loca)
      }

      this.$router.push({
        name: 'MapTripList',
        params: { stationId: station.id }
      })
    },
    pinFavorite() {
      this.$parent.pinPlaceFavorite(this.list_marker)
    },
    getRouting(data) {
      let scope = this
      this.$parent.map.Overlays.list().forEach(pin => {
        if (
          pin.element().src != scope.$parent.icon.pin_fav &&
          this.$route.path == '/'
        ) {
          scope.$parent.map.Overlays.remove(pin)
        }
      })

      this.$parent.goToFavoritePlace(data)
    },
    // WS-103
    getNearBusStop(loca, isAutoReload = false, autoSelectStop = false) {
      let scope = this
      if (loca == null) return

      scope.$parent.lastLocation = loca
      const url = `${process.env.API_URL}/front/nearby?lat=${loca.lat}&lon=${loca.lon}&locale=${scope.$parent.getUILanguage()}`

      if (!isAutoReload) this.showLoading()

      this.Api.Call({ method: 'GET', path: url })
        .then(response => {
          if (response && response.code === 200) {
            scope.search_results = response.data
            if (!autoSelectStop) {
              scope.pinNearBusStop(loca, isAutoReload)
            }
          } else {
            this.$router.push({ name: 'Login' })
          }

          scope.hideLoading()
        })
        .catch(function(error) {
          scope.hideLoading()
          console.log(error)
        }).finally(() => {
          scope.hideLoading()
          if (!scope.isMapMoveEventBinded) {
            scope.$parent.map.Event.bind('location', scope.onMapMove)
            scope.isMapMoveEventBinded = true
          }
          if (autoSelectStop) {
            if (scope.search_results instanceof Array && scope.search_results.length) {
              scope.$router.push({
                name: 'MapTripList',
                params: { stationId: scope.search_results[0].id }
              })
            } else {
              scope.autoSelectStop = false
            }
          }
        })
    },
  },
  // hooks
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!from.name) {
        vm.isFirstPage = true
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    const map = this.$parent.map
    map.Event.unbind('geolocation', this.processGeolocation)
    map.Event.unbind('geolocationError', this.processGeolocation)
    map.Event.unbind('location', this.onMapMove)
    map.Event.unbind('overlayClick', this.onPoiPinClick)
    clearTimeout(this.mapMoveDebounceTimer)
    this.clearNearbyPins()
    this.clearEventPins()
    this.$parent.clearStopFavoritePins()
    this.$parent.clearPlaceFavoritePins()
    next()
  }
}
</script>

<style lang="scss" scoped>
.details {
  background: #FFFFFF;
  border-radius: 10px;
  padding: 0;
  margin-top: 9px;

  .details-bottom {
    width: 100%;
    height: 25px;
    background: #81A9F8;
    border-radius: 0px 0px 10px 10px;
  }
}

.search-detail {
  color: #FFF;
  font-size: 14px;
  white-space: nowrap;
  margin-right: 8px;
}

.main-bus {
  color: #232323;
}

a {
  color: #444444;
}
</style>
